var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraphForDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 248.809,
    height: 58.809,
    viewBox: "0 0 248.809 58.809",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_49756",
    "data-name": "Path 49756",
    d: "M8177.557-18152.426l22.974-27.152h15.86l4,6.525h7.259l18.363,17.1,45.493-35.871,19.9,22.676,42.128-22.676h18.113l30.5,12.242,21.411-28.848",
    transform: "translate(-8176.148 18209.824)",
    fill: "none",
    stroke: "#7d96ff",
    strokeLinecap: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphForDashboard);
export default __webpack_public_path__ + "static/media/graphForDashboard.e6043740144efdf7a82a21d71a0ba7bf.svg";
export { ForwardRef as ReactComponent };